<template>
  <!-- ////////// SECTION WORK (PORTFOLIO) ////////// -->
  <section id="portfolio">
    <!-- <h1>Dave's Work</h1> -->
    <main class="portfolio">
      <h1>Check Out Some of My Work</h1>
      
      <!-- <h3 style="margin: 0;">
        I'm a Full Stack Designer who focuses on 
        providing thoughtful solutions to user based problems.
      </h3>  -->
      <p class="intro-text fade-in up-slide">
        I'm a Full Stack Designer who focuses on 
        providing thoughtful solutions to user based problems. 
        I specialize in branding, web design, UI and UX design, and of course... front-end development.
      </p>
      <!-- <h3>
        Here are a few examples of recent works. Enjoy!
      </h3> -->

      <div class="portfolio-items"> <!-- removed @keyup.esc="modalClose" not working after prev/next. Added method in created()  -->

        <!-- Portfolio Item -->
        <figure v-for="(project, index) in projects" :key="project.id" class="portfolio-item">
          <!-- <img class="portfolio-thumb" :src="require(`@/assets/portfolio/${project.thumbnail}`)"> -->
          <div class="thumb-bg" :style="{'background-image': 'url(' + require(`@/assets/portfolio/${project.hero}`) + ')'}"></div>
          <figcaption>
            <h2 class="portfolio-title">{{ project.title }}</h2>
            <p class="portfolio-desc">{{ project.subtitle }}</p>
            <a @click.prevent="modalOpen(project.id)" href="#" class="portfolio-link">View Project</a>
          </figcaption>

          <!-- ////////////// Portfolio Modal ////////////// -->
          <div class="portfolio-modal" :id="project.id">

            <div @click="modalClose" class="modal-close">
              <i class="fas fa-times"></i>
            </div>

            <div class="portfolio-header" :style="{'background-image': 'url(' + require(`@/assets/portfolio/${project.hero}`) + ')'}">
              <div class="portfolio-title-box">
                <h2 class="portfolio-title">{{ project.title }}</h2>
                <p class="portfolio-subtitle">{{ project.subtitle }}</p>
              </div>
            </div>
            <div class="portfolio-content">
              <component :is="project.component"/>
            </div>
            <nav id="bottom-nav">
              <button id="next" v-if="index > 0" @click.prevent="modalPrev(project.id)"><i class="fas fa-chevron-left"></i> Prev</button>
              <button id="prev" v-if="index + 1 < projects.length" @click.prevent="modalNext(project.id)">Next <i class="fas fa-chevron-right"></i></button>
            </nav>

          </div>
          <!-- ////////////// /Portfolio Modal ////////////// -->

        </figure>
        <!-- /Portfolio Item -->

      </div>
    </main>

  </section>
</template>

<script>
import axios from "axios";
////////// Import All Projects Here
import agentstudio from "./projects/Agentstudio";
import webworthy from "./projects/Webworthy";
import tripdaze from "./projects/Tripdaze";
import bbdc from "./projects/Bbdc";
import mazer from "./projects/Mazer";
import summit from "./projects/Summit";
////////// End of Projects List
export default {
  name: "Portfolio",
  components: {
    ////////// List All Project Components Here
    agentstudio,
    webworthy,
    tripdaze,
    bbdc,
    mazer,
    summit
    ////////// End of Project Components List
  },
  data() {
    return {
      projects: [],
      modal: null,
      currentComponent: null
    };
  },
  methods: {
    modalOpen(id) {
      this.modal = document.getElementById(id);
      this.modal.classList.add("is-open");
      this.modal.style.animation = "modalIn 500ms forwards";
      // console.log(this.modal);

      //remove main sidebar
      document.getElementById("html").style.overflowY = "hidden";
    },
    modalClose() {
      this.modal.classList.remove("is-open");
      // console.log(this.modal);

      //allow main sidebar
      document.getElementById("html").style.overflowY = "auto";
    },
    modalPrev(id) {
      // console.log(id);
      this.modalClose();
      this.modalOpen(id - 1);
    },
    modalNext(id) {
      this.modalClose();
      this.modalOpen(id + 1);
    }
  },
  mounted() {
    axios
      .get("json/portfolio.json")
      .then(response => (this.projects = response.data))
      .catch(error => console.log(error));
  },
  created() {
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.modalClose();
      }
    };
  }
};
</script>

<style lang="scss">
//PORTFOLIO ///////////////

section#portfolio {
  background-color: tomato;

  // prettier-ignore
  background: 
              url("../assets/halftone-top-almostblack8percent.png") repeat-x left top,
              // url("../assets/paintsplash.png") no-repeat left top, #dc8f56;
              url("../assets/paintsplash.png") no-repeat left top, tomato;

  min-height: calc(100vh - 11px);

  // main.portfolio {
  //   max-width: 1300px;
  // }

  .portfolio-items {
    margin: 0 auto;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 30px;
    .portfolio-item {
      width: 100%;
      height: 207px;
      padding-top: 100%; /* 1:1 Aspect Ratio */
      position: relative;
      overflow: hidden;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      // &.featured {
      // grid-column: 1 / -1;
      // grid-row: 1 / span 2;
      // }
      /* img.portfolio-thumb {
        width: 100%;
        height: 100%;
        object-fit: cover;
      } */
      .thumb-bg {
        transition: all 1.25s ease-out;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: $almost-black; /* fallback color */
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      }
      &:hover .thumb-bg,
      &:focus .thumb-bg {
        transform: scale(1.2);
      }
      figcaption {
        position: absolute;
        top: 100%;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 20px;
        background: rgba($almost-black, 0.66);
        display: flex;
        flex-direction: column;
        transition: top ease-out 0.25s;
        .portfolio-title {
          margin-bottom: auto;
        }
        .portfolio-desc {
          //
        }
        .portfolio-link {
          text-decoration: none;
          color: white;
          border: 1px solid white;
          text-align: center;
          padding: 5px;
          transition: all 0.4s;
          &:hover {
            // color: $almost-black;
            // background: white;
            background: rgba(white, 0.25);
          }
        }
      }
      &:hover figcaption,
      &:focus figcaption {
        top: 0;
      }
    }
  }

  // MODAL
  .portfolio-modal {
    position: fixed;
    z-index: 2000;
    top: 2rem;
    bottom: 2rem;
    left: 2rem;
    right: 2rem;
    background: white;
    // max-width: 795px;
    margin: 0 auto;
    color: $almost-black;
    box-shadow: 0 0 0 9999px rgba(black, 0.5);
    overflow-y: scroll;
    overflow-x: hidden;
    // transform: translateZ(0);

    display: none;
    &.is-open {
      display: block;
    }

    @include tablet-down {
      //
    }
    @include phone-down {
      top: 1rem;
      bottom: 1rem;
      left: 1rem;
      right: 1rem;
    }
    .modal-close {
      cursor: pointer;
      border-radius: 50%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
      background: white;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      position: fixed;
      // position: sticky;
      top: 10px;
      // margin-top: -15px;
      margin-left: -10px;
      // left: 50%;
      // transform: translateX(-420px);
      z-index: 99999;
      @include phone-down {
        top: 1px;
      }
    }
    .portfolio-header {
      // margin-top: -40px;
      height: 650px;
      text-align: left;
      // padding: 50px 0;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      @include phone-down {
        height: 300px;
      }
      .portfolio-title-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(black, 0.5);
        // padding: 20px;
        height: 100%;
        // width: 70%;
        color: white;
        text-shadow: 0px 0px 50px rgba(0, 0, 0, 1);
        // @include phone-down {
        //   width: 85%;
        // }
        .portfolio-title {
          margin: 0;
          font-size: 5rem;
        }
        .portfolio-subtitle {
          margin: 0;
          font-size: 3rem;
        }
      }
    }
    .portfolio-content {
      margin: 0 auto;
      .project-intro,
      .project-outro {
        max-width: 1300px;
        margin: 0 auto;
        display: flex;
        padding: 50px;
        @include tablet-down {
          flex-direction: column;
        }
        @include phone-down {
          padding: 25px;
          // flex-direction: column;
        }
        .preview {
          flex: 1;
          // @include tablet-down {
          // display: none;
          // }
          @include phone-down {
            margin-bottom: 20px;
          }
        }
        .intro-text,
        .outro-text {
          flex: 2;
          padding-left: 30px;
          line-height: 1.5;
          display: flex;
          flex-direction: column;
          @include phone-down {
            padding: 0;
          }
          p {
            font-size: 2rem;
          }
          h2 {
            margin: 0 0 25px 0;
            line-height: 1.2;
          }
          ul {
            // color: tomato;
            color: $blue-grey;
            font-weight: 200;
            padding-left: 30px;
            margin-top: auto;
            display: flex;
            flex-wrap: wrap;
            @include phone-down {
              flex-direction: column;
            }
            li {
              position: relative;
              list-style-type: none;
              float: left;
              margin: 0 80px 10px 0;
              line-height: 1.2;
              &:before {
                content: "";
                position: absolute;
                top: 4px;
                left: -28px;
                height: 16px;
                width: 16px;
                // background-color: tomato;
                background-color: $blue-grey;
                border-radius: 50%;
              }
            }
          }
        }
        .outro-text {
          padding-left: 0;
          padding-right: 30px;
        }
        .outro-img {
          flex: 3;
        }
      }
      .case-study {
        background: $light-grey;
        padding: 114px 50px 18px 50px;
        @include phone-down {
          padding: 65px 25px 1px 25px;
        }
        .browser {
          width: 100%;
          max-width: 1200px;
          margin: -32px auto 80px auto;
          position: relative;
          @include phone-down {
            margin: -32px auto 65px auto;
          }
          img {
            width: 100%;
            margin: 0 auto;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          }
        }
        .bar {
          // margin: 96px auto 80px auto;
          margin-top: 0;
          &::before {
            position: absolute;
            content: "";
            background: url("../assets/browser-bar.png") no-repeat #eee;
            height: 32px;
            width: 100%;
            z-index: 100;
            top: -32px;
            right: 0;
            left: 0;
            bottom: 0;
            margin: 0 auto;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          }
        }
      }
      a {
        color: tomato;
        text-decoration: none;
        transition: all 0.4s;
        &:hover {
          // text-decoration: underline;
          color: lighten(tomato, 10%);
          transform: translateY(10px);
        }
      }
      .portfolio-full-width {
        width: 100vw;
        max-width: initial;
        margin: 1em calc(50% - 50vw);
        height: 200px;
        object-fit: cover;
      }
      .portfolio-pull-left {
        width: 50%;
        float: left;
        margin-right: 25px;
        @include phone-down {
          width: 100%;
          float: none;
          margin: 0 0 25px 0;
        }
      }
      .portfolio-pull-right {
        width: 50%;
        float: right;
        margin-left: 25px;
        @include phone-down {
          width: 100%;
          float: none;
          margin: 0 0 25px 0;
        }
      }
    }
    #bottom-nav {
      display: flex;
      // justify-content: space-between;
      background: $light-grey;
      #prev,
      #next {
        border: none;
        background: transparent;
        padding: 30px 60px;
        color: tomato;
        cursor: pointer;
        transition: all 0.5s ease;
        @include phone-down {
          padding: 30px;
        }
      }
      #prev {
        // align-self: flex-start;
        // justify-self: flex-start;
        margin-left: auto;
        // margin-right: auto;
        &:hover {
          transform: translateX(10px);
          color: lighten(tomato, 10%);
        }
      }
      #next {
        // align-self: flex-end;
        // justify-self: flex-end;
        // margin-left: auto;
        margin-right: auto;
        &:hover {
          transform: translateX(-10px);
          color: lighten(tomato, 10%);
        }
      }
    }
  }
}

// ANIMATIONS ///////////////

@keyframes modalIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
